import { render } from "./CompetencyMatrixRender.vue?vue&type=template&id=0fe4ff36"
import script from "./CompetencyMatrixRender.vue?vue&type=script&lang=js"
export * from "./CompetencyMatrixRender.vue?vue&type=script&lang=js"
script.render = render

export default script